// @ts-nocheck
import { DcBaseComponent } from '@deleteagency/dc';
import { onMapsReady } from '../../schools-map';

const ACTIONS = Object.freeze({
    STATIONS: 'stations',
    SCHOOLS: 'schools',
});
const CLASS_ACTIVE = 'is-active';
export default class PropertyMapsComponent extends DcBaseComponent {
    static getNamespace() {
        return 'property-maps';
    }

    static getRequiredRefs() {
        return ['triggers', 'container'];
    }

    onInit() {
        this.id = this.options.id;
        this.activeTrigger = this.refs.triggers.find(el => el.classList.contains(CLASS_ACTIVE));

        if (this.activeTrigger) {
            let activeAction = this.activeTrigger.dataset.action;
            switch (activeAction) {
                case ACTIONS.STATIONS:
                    this.startTab = 'location';
                    break;
                case ACTIONS.SCHOOLS:
                    this.startTab = 'schools';
                    break;
                default:
                    break;
            }
        }

        onMapsReady(this._initMap);
        this._addListeners();
    }

    _addListeners() {
        const { triggers } = this.refs;
        triggers.forEach(this._addListener);
    }

    _addListener = (el) => {
        this.addListener(el, 'click', this._onTriggerClick);
    };

    _onTriggerClick = (e) => {
        const action = e.target.dataset.action;
        switch (action) {
            case ACTIONS.STATIONS:
                showTransportTab(this.id);
                break;
            case ACTIONS.SCHOOLS:
                showSchoolsTab(this.id);
                break;
            default:
                break;
        }
    };

    _initMap = () => {
        const { lat, lng, mapstyle, icon, zoom } = this.options;
        window?.loadLocratingPlugin({
            id: this.id,
            lat,
            lng,
            type: 'all',
            starttab: this.startTab || 'location',
            hidemenu: true,
            icon: icon || `${window.location.origin}/dist/static-images/pin.png`,
            mapstyle: mapstyle || 'voyager',
            zoom: zoom || 14,
        });
    };

    onDestroy() {}
}
